/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Not_FoundInputs */

const cs_blog_not_found = /** @type {(inputs: Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek nenalezen.`)
};

const en_blog_not_found = /** @type {(inputs: Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog post not found.`)
};

/**
* | output |
* | --- |
* | "Blog post not found." |
*
* @param {Blog_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_not_found = /** @type {((inputs?: Blog_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_not_found(inputs)
	return cs_blog_not_found(inputs)
});